import React, { useContext, useEffect } from 'react'
import { NextPage } from 'next'
import Image from 'next/image'
import GreaterSection from '../../components/Greater/GreaterSection'
import axios from 'axios'
import { API_BASE_URL, BASE_URL } from '../../lib/constants'
import { MainContext } from '../../contexts/MainContext'
import Head from 'next/head'
import ShowSpecialGnydm from '../../public/assets/img/slider/special-banner.jpg'
import MetaTags from '../../components/MetaTags/MetaTags'
interface greaterPage {
	meta_title: string
	meta_keywords: string
	meta_description: string
}
export interface greaterShowpro {
	[category: string]: string[]
}
export interface product {
	id: number
	parent_id: number
	type: string
	name: string
	slug: string
	sku: string
	sku_stripped: string
	price: number
	price_catalog: number
	price_discounted: number | null
	price_discounted_start: null | number
	price_discounted_end: null | number
	in_stock: string
	check_quantity: string
	quantity: null | number
	ship_type: string
	weight: number
	taxable: string
	short_description: string
	full_description: string
	length: null | number
	meta_title: string
	meta_keywords: string
	meta_description: string
	visibility: string
	featured: string
	hot: string
	new: string
	is_canonical: string
	do_index: string
	position: number | null
	status: string
	image: string
	resized: string
	image_org: string | null
	image_updated: string
	views: number
	sales: number
	sub_hash: string
	files: File[]
}
export interface greaterShow {
	page: greaterPage
	show_products: greaterShowpro
	products: product[][]
}
export const getServerSideProps = async (context) => {
	const res = await axios.get(`${API_BASE_URL}show-special/greater-ny-dental-meeting`).then((response) => {
		return response
	})
	return {
		props: { shows: res?.data }
	}
}

const Greater = ({ shows }: { shows: greaterShow }) => {
	const { setIsLoading } = useContext(MainContext)
	const special_header_img = 'show-special-gnydm.jpg'

	useEffect(() => {
		setIsLoading(false)
	}, [setIsLoading, shows])

	return (
		<>
			<MetaTags title={`${shows?.page?.meta_title} - GerDentUSA`} description={shows?.page?.meta_description} keywords={shows?.page?.meta_keywords} />
			{/* <Head>
                <title>{`${shows.page.meta_title} - GerDentUSA`}</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="description" content={shows.page.meta_description} />
                <meta name="keywords" content={shows.page.meta_keywords} />
            </Head> */}
			<div className='equine-special-disc relative mb-10 md:mb-20'>
				{/* hero section */}
				<section className='equine-special-disc hero relative'>
					<div className='overlay absolute top-0 left-0 w-full h-full' />
					<div className='hero-content flex flex-col justify-center items-center text-white text-3xl sm:text-5xl md:text-6xl lg:text-7xl relative z-10 text-center w-full'>
						<div className='w-full block'>
							<Image src={ShowSpecialGnydm} alt='Virtual Convention' layout='responsive' />
						</div>
					</div>
				</section>
				{/* HeroSection */}

				{/* equine insturments types */}
				<GreaterSection shows={shows} />
			</div>
		</>
	)
}

export default Greater
